import { render, staticRenderFns } from "./WizardSection.vue?vue&type=template&id=3c20a146&scoped=true&"
import script from "./WizardSection.vue?vue&type=script&lang=ts&"
export * from "./WizardSection.vue?vue&type=script&lang=ts&"
import style0 from "./WizardSection.vue?vue&type=style&index=0&id=3c20a146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c20a146",
  null
  
)

export default component.exports